/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The ObservationstypeGroupsObservationTypeGroup model module.
 * @module model/ObservationstypeGroupsObservationTypeGroup
 * @version v0.3
 */
export default class ObservationstypeGroupsObservationTypeGroup {
  /**
   * Constructs a new <code>ObservationstypeGroupsObservationTypeGroup</code>.
   * @alias module:model/ObservationstypeGroupsObservationTypeGroup
   * @class
   * @param name {String} Observation Type Group Name
   * @param observationTypeIds {Array.<String>} 
   */
  constructor(name, observationTypeIds) {
    this.name = name;
    this.observationTypeIds = observationTypeIds;
  }

  /**
   * Constructs a <code>ObservationstypeGroupsObservationTypeGroup</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ObservationstypeGroupsObservationTypeGroup} obj Optional instance to populate.
   * @return {module:model/ObservationstypeGroupsObservationTypeGroup} The populated <code>ObservationstypeGroupsObservationTypeGroup</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ObservationstypeGroupsObservationTypeGroup();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('observation_type_ids'))
        obj.observationTypeIds = ApiClient.convertToType(data['observation_type_ids'], ['String']);
    }
    return obj;
  }
}

/**
 * Observation Type Group Name
 * @member {String} name
 */
ObservationstypeGroupsObservationTypeGroup.prototype.name = undefined;

/**
 * @member {Array.<String>} observationTypeIds
 */
ObservationstypeGroupsObservationTypeGroup.prototype.observationTypeIds = undefined;

